import axios from 'axios';
import authConfig from '../auth_config.json';
import moment from 'moment'

class BookingService {
    domain = authConfig.domain;
    domainOnly = authConfig.domainOnly;
    domainGraphql = authConfig.domainGraphql;

    getOptions(playgroundId ) {
        let token = localStorage.getItem('token');
        return new Promise((resolve, reject) => {

            axios({
                url: this.domain+'playground/options/'+playgroundId,
                method: 'GET',
                headers: {Authorization: 'Bearer '+token},
            })
                .then(resp => {
                    return resolve(resp.data)
                })
                .catch(err => {
                    return reject(err)
                })


        })
    }

    getDuration(playgroundId, startDate ) {
        let token = localStorage.getItem('token');
        return new Promise((resolve, reject) => {

            axios({
                url: this.domain+'booking/get_possible_booking_duration?playground_id='+playgroundId+'&startDate='+startDate,
                method: 'GET',
                headers: {Authorization: 'Bearer '+token},
                data: {
                    playground_id: playgroundId,
                    startDate: startDate,
                },
            })
                .then(resp => {
                    return resolve(resp.data)
                })
                .catch(err => {
                    return reject(err)
                })


        })
    }

    getOption(playgroundId) {
        let token = localStorage.getItem('token');
        return new Promise((resolve, reject) => {
            axios({
                url: this.domain+'playground/options/'+playgroundId,
                method: 'GET',
                headers: {Authorization: 'Bearer '+token}
            })
                .then(resp => {
                    return resolve(resp.data);
                })
                .catch(err => {
                    return reject(err)
                })
        })
    }

    addBookingActivity(data, stringDate, slot) {
        let token = localStorage.getItem('token');
        return new Promise((resolve, reject) => {

            axios({
                url: this.domain+'activity-booking/add/'+slot.id+'/'+stringDate,
                method: 'POST',
                headers: {Authorization: 'Bearer '+token},
                data: data,
            })
            .then(resp => {
                return resolve(resp.data)
            })
            .catch(err => {
                return reject(err)
            })
        })

    }

    addBooking(data) {

        let token = localStorage.getItem('token');
        return new Promise((resolve, reject) => {
            axios({
                url: this.domain+'bookings',
                method: 'POST',
                headers: {Authorization: 'Bearer '+token},
                data: data,
            })
            .then(resp => {
                return resolve(resp.data)
            })
            .catch(err => {
                return reject(err)
            })
        })
    }

    cancelBooking(id) {

        let token = localStorage.getItem('token');
        return new Promise((resolve, reject) => {
            axios({
                url: this.domainOnly+id,
                method: 'DELETE',
                headers: {Authorization: 'Bearer '+token}
            })
                .then(resp => {
                    return resolve(resp.data)
                })
                .catch(err => {
                    return reject(err)
                })
        })
    }

    cancelActivity(id) {
        let token = localStorage.getItem('token');
        return new Promise((resolve, reject) => {

                axios({
                    url: this.domain+'activity-booking/canceled/'+slot.id+'/'+id,
                    method: 'POST',
                    headers: {Authorization: 'Bearer '+token},
                })
                    .then(resp => {
                        return resolve(resp.data)
                    })
                    .catch(err => {
                        return reject(err)
                    })
            })
    }

    myBookings(user) {

        let token = localStorage.getItem('token');

        let now = moment().format();

        let queryParams = `user: "`+user.id+`",`;

        queryParams += `
            canceled: false,
            fromClub: {
                after: "`+now+`"
            }, 
            order: {
                fromClub: "asc"
            },
        `;

        let query = `
                    query {
                        bookings(`+queryParams+`) {
                            edges {
                                node {
                                    id
                                    name
                                    fromClub
                                    toClub
                                    fromClient
                                    toClient
                                    price
                                    club {
                                        id
                                    }
                                    playground {
                                        name
                                    }
                                }
                                cursor
                            }
                            pageInfo {
                                endCursor
                                hasNextPage
                            }
                        }
                    }`;

        return new Promise((resolve, reject) => {
            axios({url: this.domainGraphql,
                method: 'POST',
                headers: {Authorization: 'Bearer '+token},
                data: {
                    query: query
                }
            })
            .then(resp => {

                return resolve(resp.data)
            })
            .catch(err => {
                return reject(err)
            })
        })
    }


    myActivitys(user) {

        let token = localStorage.getItem('token');

        let now = moment().format();

        let queryParams = `user: "`+user.id+`"`;

        let query = `
                    query {
                        activities(`+queryParams+`) {
                            edges {
                                node {
                                    id
                                    price
                                    
                                    countAttenders
                                }
                                cursor
                            }
                            pageInfo {
                                endCursor
                                hasNextPage
                            }
                        }
                    }`;

        return new Promise((resolve, reject) => {
            axios({url: this.domainGraphql,
                method: 'POST',
                headers: {Authorization: 'Bearer '+token},
                data: {
                    query: query
                }
            })
                .then(resp => {

                    return resolve(resp.data)
                })
                .catch(err => {
                    return reject(err)
                })
        })
    }

}

const bookingService = new BookingService();

export default bookingService;
